import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
/*
 * Transform a month number into a month name
 * Takes an month argument that defaults to 1.
 * Usage:
 *   value | monthName:format
 * Example:
 *   {{ 10 |  monthName:'MMM-y' }}
 *   formats to: Oct
*/
@Pipe({
  name: 'monthName'
})
export class MonthNamePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(month: number, format: string): string {
    // MMM default format
    let form = !format ? 'MMM' : format;
    return this.datePipe.transform(new Date(0, month - 1), form);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/month-year-picker/month-name.pipe.ts